import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalLayout from '../layouts/ModalLayout';

interface InactiveReasonModalProps {
  open: boolean;
  setOpen: (bool: boolean) => void;
  reason: string;
  connectionName?: string;
}

export default function InactiveReasonModal({
  open,
  setOpen,
  reason,
  connectionName,
}: InactiveReasonModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      closeButton
      className="relative transform overflow-hidden rounded-2xl bg-secondary-50 p-8 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
      <div className="flex flex-col gap-4">
        <div className="border-b border-primary-300 pb-4">
          <h3 className="text-2xl font-medium text-primary-900">
            {t('page.dashboard.table.columnLabel.inactiveReason')}
          </h3>
          {connectionName && (
            <p className="mt-1 text-sm text-gray-500">{t('page.dashboard.table.columnLabel.inactiveReasonDescription', { name: connectionName })}</p>
          )}
        </div>
        
        <div className="rounded-xl bg-primary-100 p-4 text-primary-900">
          <p className="text-sm leading-relaxed">{reason}</p>
        </div>
      </div>
    </ModalLayout>
  );
}
